// Collection extends the built in Array class…
// https://github.com/wesbos/es6-articles/blob/master/54%20-%20Extending%20Arrays%20with%20Classes%20for%20Custom%20Collections.md

import {onlyUnique} from "../helpers/array";

export default class Collection extends Array {

    constructor(...items) {
        super(...items);
    }

    isEmpty(){
        return this.length === 0;
    }

    // Returns a new array with null and undefined items removed.
    compact() {
        return this.__filter( item => item != null );
    }

    uniq() {
        return this.__filter(onlyUnique);
    }

    // Find the first item with a matching `propValue` in the specified `propName`.
    findByProp(propName, propValue) {
        if (this.isEmpty()) { return }
        return this.__find(item => item[propName] === propValue );
    }

    // Find all items where the specified `propName` includes any of `propValues`.
    filterByProp(propName, propValues) {
        if (this.isEmpty()) { return [] }
        if (!Array.isArray(propValues)) { propValues = [propValues] }
        return this.__filter( item => propValues.includes(item[propName]) );
    }

    // Pass in a propName or Function.
    // Function to return a sorting criteria.
    groupByArray(key) {
        const reducer = (rv, x) => {
            let v = (key instanceof Function ? key(x) : x[key]);
            let el = rv.find((r) => r && r.key === v);
            if (el) {
                el.values.push(x);
            } else {
                rv.push({ key: v, values: [x] });
            }
            return rv;
        };
        return this.reduce(reducer, []);
    }



    // This polyfill for the native `filter` method can be useful to avoid using the native version.
    // This might be necessary when wanting to use the native method but `prototype.js` is overriding it with a version that isn't equivalent.
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter#Polyfill
    __filter(func, thisArg) {
        'use strict';
        if ( ! ((typeof func === 'function') && this) )
            throw new TypeError();

        var len = this.length >>> 0,
            res = new Array(len), // preallocate array
            t = this, c = 0, i = -1;
        if (thisArg === undefined){
            while (++i !== len){
                // checks to see if the key was set
                if (i in this){
                    if (func(t[i], i, t)){
                        res[c++] = t[i];
                    }
                }
            }
        } else{
            while (++i !== len){
                // checks to see if the key was set
                if (i in this){
                    if (func.call(thisArg, t[i], i, t)){
                        res[c++] = t[i];
                    }
                }
            }
        }

        res.length = c; // shrink down array to proper size
        return res;
    }

    // This polyfill for the native `find` method can be useful to avoid using the native version.
    // This might be necessary when wanting to use the native method but `prototype.js` is overriding it with a version that isn't equivalent.
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find#Polyfill
    __find(predicate) {

        // 1. Let O be ? ToObject(this value).
        if (this == null) {
            throw TypeError('"this" is null or not defined');
        }

        var o = Object(this);

        // 2. Let len be ? ToLength(? Get(O, "length")).
        var len = o.length >>> 0;

        // 3. If IsCallable(predicate) is false, throw a TypeError exception.
        if (typeof predicate !== 'function') {
            throw TypeError('predicate must be a function');
        }

        // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
        var thisArg = arguments[1];

        // 5. Let k be 0.
        var k = 0;

        // 6. Repeat, while k < len
        while (k < len) {
            // a. Let Pk be ! ToString(k).
            // b. Let kValue be ? Get(O, Pk).
            // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
            // d. If testResult is true, return kValue.
            var kValue = o[k];
            if (predicate.call(thisArg, kValue, k, o)) {
                return kValue;
            }
            // e. Increase k by 1.
            k++;
        }

        // 7. Return undefined.
        return undefined;
    }

}